import { useMemo } from "react";
import { useProducts } from "@/entities/settings/hooks";
import { ProductV2 } from "../types";

export const useProductList = () => {
  const { data, isLoading, refetch } = useProducts();

  const products = useMemo<ProductV2[]>(
    () =>
      (data?.products ?? []).map((product) => ({
        id: product.id,
        name: product.name,
        description: product.description,
        serviceItems: (product.serviceItems ?? []).map((item) => ({
          ...item,
          productId: item.productId || product.id
        }))
      })),
    [data]
  );

  return { products, isLoading, refetch };
};
